import { Component, Input, OnInit } from '@angular/core';
import { TitledModalWithContentService } from 'src/app/shared/services/titled-modal-with-content.service';
import { EventTerms } from '../../event.interface';

@Component({
  selector: 'app-event-terms-section',
  templateUrl: './event-terms-section.component.html',
  styleUrls: ['./event-terms-section.component.scss']
})
export class EventTermsSectionComponent implements OnInit {
  @Input() eventTerms:EventTerms;
  constructor(
    public titledModal: TitledModalWithContentService,

  ) { }

  ngOnInit(): void {
  }

}
